import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { HeadingRegularVariants, Label3 } from "../../index";
import { Flex } from "theme-ui";
export const FilterMenuHeader = ({ label, products }) => {
    let header = null;
    if (label) {
        header = (_jsx("h3", { sx: {
                variant: `text.${HeadingRegularVariants.sixth}`,
                color: "white.0"
            }, children: label }));
    }
    return (_jsxs(Flex, { sx: {
            flexDirection: "column",
            height: "auto",
            flexFlow: "column wrap",
            justifyContent: "center",
            pr: [0, null, null, 32]
        }, children: [header, _jsx(Label3, { sx: { color: "grey.3" }, children: products })] }));
};
//# sourceMappingURL=FilterMenuHeader.js.map